// eslint-disable-next-line no-shadow
enum MessageType {
  CLIENT,
  SELLER,
  ROBOT,
}
export default MessageType;
